import TestclientPharmaChart from "../../../../src/client/testclient-pharma/json/shipping-process.json";
import ChartTestclientPharma from "../../../../src/client/testclient-pharma/interactions/chart/Chart.js";
import * as React from 'react';
export default {
  TestclientPharmaChart,
  ChartTestclientPharma,
  React
};